import React from 'react';
import { SCENARIO_CONFIGS } from '../../config/scenarioConfigs';
import { SCENARIO_DESCRIPTIONS } from '../../config/scenarioDescriptions';

// Helper function to get display name for scenarios
const getScenarioDisplayName = (scenario) => {
  if (scenario === 'net_zero_futures_dvl_shift_high_transstshiftec_2001') {
    return "Citizens Panel";
  }
  return scenario;
};

// Predefined color classes for scenarios
const SCENARIO_COLOR_CLASSES = {
  current: {
    bg: 'bg-gray-600',
    hover: 'hover:bg-gray-700',
    text: 'text-gray-100'
  },
  steer: {
    bg: 'bg-blue-600',
    hover: 'hover:bg-blue-700',
    text: 'text-blue-100'
  },
  shift: {
    bg: 'bg-green-600',
    hover: 'hover:bg-green-700',
    text: 'text-green-100'
  },
  transform: {
    bg: 'bg-purple-600',
    hover: 'hover:bg-purple-700',
    text: 'text-purple-100'
  }
};

const QuickChoicesButton = ({
  isQuickChoicesOpen,
  setIsQuickChoicesOpen,
  sectorImpact
}) => {
  // Determine the current scenario and ambition level
  const getCurrentScenarioAndAmbition = () => {
    console.log('Current Sector Impact:', sectorImpact);
    console.log('Scenario Configs:', SCENARIO_CONFIGS);

    // If sectorImpact is undefined or null, return a default
    if (!sectorImpact) {
      console.warn('sectorImpact is undefined or null');
      return { scenario: 'current', ambition: 'low' };
    }

    // Check each scenario configuration
    for (const [scenarioName, scenarioVariants] of Object.entries(SCENARIO_CONFIGS)) {
      for (const [variant, config] of Object.entries(scenarioVariants)) {
        const isMatchingScenario =
          sectorImpact.food === config.food &&
          sectorImpact.buildings === config.buildings &&
          sectorImpact.transport === config.transport &&
          sectorImpact.industry === config.industry;

        if (isMatchingScenario) {
          console.log(`Matched scenario: ${scenarioName} with ${variant} ambition`);
          return { scenario: scenarioName, ambition: variant };
        }
      }
    }

    // console.log('No matching scenario found, returning current with low ambition');
    return { scenario: 'current', ambition: 'low' };
  };

  const currentSelection = getCurrentScenarioAndAmbition();
  const scenarioColors = SCENARIO_COLOR_CLASSES[currentSelection.scenario] || SCENARIO_COLOR_CLASSES.current;
  const displayName = getScenarioDisplayName(currentSelection.scenario);

//   console.log('Current Selection:', currentSelection);
//   console.log('Scenario Color:', scenarioColors);

  return (
    <button
      onClick={() => setIsQuickChoicesOpen(!isQuickChoicesOpen)}
      className={`fixed bottom-24 right-10 ${scenarioColors.bg} ${scenarioColors.hover} ${scenarioColors.text} p-3 rounded-full shadow-2xl z-50 flex items-center justify-center
      ${isQuickChoicesOpen ? 'rotate-45' : ''} transition-transform duration-300`}
      aria-label="Quick Sector Choices"
    >
      <div className="text-center">
           <p className="text-sm font-medium  opacity-80 capitalize">
             {currentSelection.ambition === 'low' ? 'less' : 'more'} change
        </p>
        <p className="text-xs capitalize">
          {displayName} Scenario
        </p>

        <p className="text-xs underline mt-1">Change</p>
      </div>
    </button>
  );
};

export default QuickChoicesButton;
